import {Action} from '@ngrx/store';
import {routerReducer} from '@ngrx/router-store';

import {shipmentHistoryReducer, ShipmentHistoryState} from './shipment-history.reducer';
import {countriesReducer, CountriesState} from './countries.reducer';
import {profileReducer, ProfileState} from './profile.reducer';
import {footerReducer, FooterState} from './footer.reducer';
import {initialInfoReducer, InitialInfoState} from '@store/reducers/initial-info.reducer';
import {orderCreationReducer, OrderCreationState} from '@store/reducers/order-creation.reducer';
import {orderCompletionReducer, OrderCompletionState} from '@store/reducers/order-completion.reducer';
import {shipmentsReducer, ShipmentsState} from '@store/reducers/shipments.reducer';
import {modalReducer, ModalState} from '@store/reducers/modal.reducer';
import {snackbarReducer, SnackbarState} from '@store/reducers/snackbar.reducer';
import {RouterState} from '@store/reducers/router.reducer';
import {addressesReducer, AddressesState} from '@store/reducers/addresses.reducer';

export * from './shipment-history.reducer';
export * from './countries.reducer';
export * from './profile.reducer';
export * from './footer.reducer';
export * from './order-creation.reducer';
export * from './order-completion.reducer';
export * from './shipments.reducer';
export * from './initial-info.reducer';
export * from './router.reducer';
export * from './addresses.reducer';

export const reducers = {
  shipmentHistory: shipmentHistoryReducer,
  countries: countriesReducer,
  profile: profileReducer,
  footer: footerReducer,
  initialInfo: initialInfoReducer,
  orderCreation: orderCreationReducer,
  orderCompletion: orderCompletionReducer,
  shipments: shipmentsReducer,
  router: routerReducer,
  snackbar: snackbarReducer,
  modal: modalReducer,
  addresses: addressesReducer,
};

export interface AppState {
  shipmentHistory: ShipmentHistoryState;
  countries: CountriesState;
  profile: ProfileState;
  footer: FooterState;
  initialInfo: InitialInfoState;
  orderCreation: OrderCreationState;
  orderCompletion: OrderCompletionState;
  shipments: ShipmentsState;
  modal: ModalState;
  snackbar: SnackbarState;
  router: RouterState;
  addresses: AddressesState;
}

export interface ActionWithPayload<T> extends Action {
  payload: T;
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/index.ts